module.exports = "https://www.gc-qa.gnp.com.mx/442aa81ece6ae9aaf7658cb134a22b31.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/target.png
// module id = 991
// module chunks = 0 1